import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 28 23',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M6.606,75.021a2.394,2.394,0,1,0,0,4.786l.555.006c2.144,0,2.464-1.2,2.464-1.921A3.293,3.293,0,0,0,6.606,75.021Zm.555,3.354c-.192,0-.384-.006-.555-.006-.682,0-1.137-.382-1.137-.955s.455-.955,1.137-.955,1.706.86,1.706,1.433C8.312,78.321,7.735,78.375,7.16,78.375Zm14.232-3.354a3.292,3.292,0,0,0-3.018,2.871c0,.718.32,1.921,2.464,1.921l.555-.006a2.394,2.394,0,1,0,0-4.786Zm0,3.348c-.171,0-.363.006-.555.006-.576,0-1.152-.054-1.152-.483,0-.573,1.024-1.433,1.706-1.433s1.137.382,1.137.955-.455.955-1.137.955Zm6.278-8.442a2.139,2.139,0,0,0-1.861-1.136H23.093l-.441-1.483A4.433,4.433,0,0,0,18.492,64H9.505a4.432,4.432,0,0,0-4.159,3.307L4.9,68.79H2.188A2.139,2.139,0,0,0,.327,69.927a2.577,2.577,0,0,0-.1,2.331l.316.7a2.715,2.715,0,0,0,.93,1.111,5.041,5.041,0,0,0-.6,2.394v7.667A2.761,2.761,0,0,0,3.5,87h.875A2.761,2.761,0,0,0,7,84.125v-.958H21v.958A2.761,2.761,0,0,0,23.624,87H24.5a2.761,2.761,0,0,0,2.625-2.875V76.458a5.044,5.044,0,0,0-.6-2.395,2.71,2.71,0,0,0,.93-1.112l.316-.692A2.58,2.58,0,0,0,27.67,69.927ZM7.01,67.9a2.654,2.654,0,0,1,2.5-1.985h8.987a2.654,2.654,0,0,1,2.5,1.984l1.119,3.764H5.89ZM2.114,72.1,1.8,71.4a.514.514,0,0,1,.019-.466.422.422,0,0,1,.372-.228H4.334l-.353,1.187a4.268,4.268,0,0,0-1.258.676A.857.857,0,0,1,2.114,72.1ZM5.249,84.125a.921.921,0,0,1-.875.958H3.5a.921.921,0,0,1-.875-.958v-.958H5.249Zm20.124,0a.921.921,0,0,1-.875.958h-.875a.921.921,0,0,1-.875-.958v-.958h2.625Zm0-4.792v1.917H2.624V76.458a2.761,2.761,0,0,1,2.625-2.875h17.5a2.761,2.761,0,0,1,2.625,2.875v2.875ZM26.2,71.4l-.316.692a.857.857,0,0,1-.61.477,4.261,4.261,0,0,0-1.258-.676l-.353-1.187h2.146a.422.422,0,0,1,.372.228A.511.511,0,0,1,26.2,71.4Z"
          transform="translate(0.001 -64)"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
